import React from 'react';
import PropTypes from 'prop-types';

export default function CuttedListIcon({ color }) {
  return (
    <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M4.25 5C4.25 4.58579 4.58579 4.25 5 4.25H13C13.4142 4.25 13.75 4.58579 13.75 5C13.75 5.41421 13.4142 5.75 13 5.75H5C4.58579 5.75 4.25 5.41421 4.25 5Z" fill={color}/>
      <path fillRule="evenodd" clipRule="evenodd" d="M4.25 9C4.25 8.58579 4.58579 8.25 5 8.25H13.13C13.5442 8.25 13.88 8.58579 13.88 9C13.88 9.41421 13.5442 9.75 13.13 9.75H5C4.58579 9.75 4.25 9.41421 4.25 9Z" fill={color}/>
      <path fillRule="evenodd" clipRule="evenodd" d="M2 1.75C1.86221 1.75 1.75 1.86221 1.75 2V16.7874L3.33145 15.9962C3.54266 15.8906 3.7913 15.8906 4.00252 15.9962L6.3335 17.1622L8.66448 15.9962C8.87561 15.8906 9.12414 15.8906 9.3353 15.9961L11.6665 17.1612L13.9975 15.9952C14.2087 15.8896 14.4573 15.8896 14.6685 15.9952L16.25 16.7864V2C16.25 1.86221 16.1378 1.75 16 1.75H2ZM0.25 2C0.25 1.03379 1.03379 0.25 2 0.25H16C16.9662 0.25 17.75 1.03379 17.75 2V17.191C17.75 18.1227 16.7708 18.7227 15.9414 18.3092L15.9405 18.3088L14.333 17.5046L12.2255 18.5588L12.2235 18.5598C11.8724 18.7341 11.4606 18.7341 11.1095 18.5598L11.1077 18.5589L9.00014 17.5055L6.89252 18.5598L6.8905 18.5608C6.5394 18.7351 6.1276 18.7351 5.7765 18.5608L5.77448 18.5598L3.66702 17.5056L2.05955 18.3098L2.05699 18.311C1.22866 18.7215 0.25 18.1229 0.25 17.191V2Z" fill={color}/>
      <path fillRule="evenodd" clipRule="evenodd" d="M4.25 13C4.25 12.5858 4.58579 12.25 5 12.25H10C10.4142 12.25 10.75 12.5858 10.75 13C10.75 13.4142 10.4142 13.75 10 13.75H5C4.58579 13.75 4.25 13.4142 4.25 13Z" fill={color}/>
    </svg>

  )
}

CuttedListIcon.propTypes = {
  color: PropTypes.string
}

CuttedListIcon.defaultProps = {
  color: '#A39EB8'
}
